export default {
  local: 'English',
  en: 'English',
  zh: '中文',
  ok: 'Confirm',
  cancel: 'Cancel',
  survivalDay: 'Survival day',
  cellCount: 'Cell count',
  externalEnvironment: 'External environment',
  reproductive: 'Reproductive',
  adaptability: 'Adaptability',
  survivability: 'Survivability',
  geneticNumber: 'Genetic Number: ',
  naturallyReproductive: 'Natural Reproductive: ',
  naturallyAdaptable: 'Natural Adaptability: ',
  naturalSurvivability: 'Natural Survivability: ',
  lifeCycle: 'Life cycle',
  reproduce: 'Reproduce',
  evolution: 'Evolution',
  mutations: 'Mutations',
  dormant: 'Dormant',
  apoptosis: 'Apoptosis',
  genetic: 'Genetic',
  worldData: 'World data',
  cellInformation: 'Cell Information',
  cellData: 'Cell Data',
  howToPlay: 'How to play?',
  loading1: 'Access to genetic information in..',
  loading2: 'Read world number <{{id}}> in profile..',
  loading3: 'Retrieving cell number <{{id}}> information..',
  whatIsCellEvolution: 'Cell Evolution is the first decentralized sandbox business strategy blockchain-based game. All players act as a cell group. In this group, we need to balance our overall adaptability, survivability, and reproduction. When the direction of our cell population is out of balance, we will fail to evolve as a whole. This is not just a game, but also a real social group experiment. You play a primitive cell here, and countless you will determine our common destiny. Next, start the evolutionary journey!',
  whatIsSurvivalDays: 'Survival days represent the number of days that have been alive in the game, and as many as possible survive to get a higher score.',
  whatIsCellCount: 'The number of cells represents the number of cells you have. Cultivate as many cells as possible to get a higher score.',
  whatIsExternalEnvironment: 'The external environment will increase with the increase in survival days, and the high-risk environment will threaten the life cycle.',
  whatIsReproduction: 'Reproduction determines the number of reproductions each time.',
  whatIsAdaptability: 'Adaptability determines the success rate of mutation.',
  whatIsSurvivability: 'Survivability determines the resistance of cells against the external environment.',
  whatIsLifeCycle: 'The life cycle determines the survival day of the cell. Try to sleep before the end of the life cycle.',
  whatIsMultiplication: 'Multiplication can increase the number of cells.',
  whatIsEvolution: 'Evolution can enhance reproductive adaptability and survivability under certain conditions.',
  whatIsMutation: 'Mutation can also enhance reproductive adaptability and survivability under certain conditions. It is said that there are three modes of mutation.',
  whatIsDormancy: 'Dormancy can restore the life cycle, and the number of restorations is related to survivability and the external environment. Use your own strategies as much as possible to develop unique cells, a total of more than a thousand titles will be reflected in the game.',
  whatIsApoptosis: "Apoptosis is a biological term, and it is also a very important discovery in nature. Some cell sacrifices are conducive to the maintenance and renewal of the organism. After they complete their mission, they quietly withdraw. Here we use this feature to give the world tinkers more room to play. When you choose apoptosis, the cell's life cycle will immediately return to zero, and the highest attributes of reproductiveness, adaptability, and survivability will be partially integrated into the world's DNA. Sacrifice oneself and achieve the world.",
  whatIsGenetic: "In the beginning, genetic cells can inherit certain attributes of the world's DNA as their initial attributes. There is a chance of inheriting better attributes, and there are also chances of inheriting lower attributes. However, if you want to hit a player with a high score, you can inherit the three higher initial attributes as much as possible as a starting point. Players who want to mend the world can choose a genetic start. This also increases the linkage between the world and individual cells, motivating everyone to integrate into the world more and hit a higher world score, so that it is easier to gain an initial advantage for your subsequent games.",
  whatIsWorldData: 'World data can get all the data of the current ethnic group.',
  whatIsCellData: 'The cell data can be read arbitrarily from the cell data that has undergone DNA fusion.',
  BeautyOfTheUniverse: 'Beauty of the Universe',
  BeautyOfTheUniverse1: 'There are countless worlds in the vast universe, and whether you can evolve to the world you want requires teamwork and a sense of cooperation.',
  BeautyOfTheUniverse2: 'he ideologies and conditions of various universes are different. This is a diversified world.The Zerg world needs abundant cells, while the spiritual world will not have too many cells.',
  BeautyOfTheUniverse3: 'Each player has a choice of 5^99, which is also 1.57e+69 possibilities. Countless players have gathered into the world. There are countless chances, mutations, and apoptosis. This is true from 1 to infinite possibilities, after countless times in the end, the world converges into its final appearance.We think this is the beauty of mathematics and the beauty of real science fiction!',
  whatIsinfoTitle: 'Cell evolution needs an Ethereum wallet installed on your device so that DNA fusion can be carried out and more gameplay can be experienced.',
  metamaskLink: 'Download MetaMask',
  note: 'Note:',
  noteContent: 'The original intention of designing this game is to make a real game. It is not a traditional game such as blockchain issuance or Bosha. We think a blockchain is a tool that makes the game process and data more in the case of high efficiency and transparency, through own on-chain logic and own ecological logic, the game process can be more unique. Then we found that it is different from the traditional meaning. If there is really a game that allows everyone to participate in the ecology, and countless individuals determine the direction of the world, then this is not a stand-alone operation, a simple scoreboard, but a true anonymous group game, there are players who chase high scores, there are players who cooperate in groups, there are novices, there are also high players, there are creators, and there are also tinkers. Various individuals build a real blockchain game, Cell Evolution. I hope you like it. -Ling',
  successfullReproduction: 'Successful reproduction',
  successfullEvolutionary: 'Successful evolutionary',
  EvolutionFailure: 'Evolution failure',
  whyEvolutionFailure: 'Needs a balance of attributes to evolve',
  successfullMutations: 'Successful mutations',
  mutationsFailure: 'Mutations failure',
  whyMutationsFailure: 'Needs at least 1 cell to mutate',
  successfullDormant: 'Successful dormant',
  dormantFailure: 'Dormant failure',
  whyDormantFailure1: 'Needs at least 1 cell to be dormant',
  whyDormantFailure2: 'Data errors, cheating or network lag ~',
  successfullGenetic: 'Successful genetic',
  geneticFailure: 'Genetic failure',
  whyGeneticFailure1: 'Can only be inherited when the survival date is 1',
  whyGeneticFailure2: 'Wallet information not obtained',
  whyGeneticFailure3: "Please switch the metamask's chainId to",
  whyGeneticFailure4: 'Wallet anomalies',
  geneticFailureContent: 'Can only be inherited when the survival day is 1.',
  afterApoptosis: 'After apoptosis, the game will end directly. Is apoptosis confirmed?',
  fusionDNA: 'Fusion DNA...',
  fusionDNASuccess: 'Fusion DNA success',
  fusedCellID: 'fused cell ID ',
  uploadFailure: 'Upload failure',
  whyFusedCellFailure1: 'Wallet information not obtained',
  whyFusedCellFailure2: "Please switch the metamask's chainId to",
  whyFusedCellFailure3: 'Wallet anomalies',
  enterTheWordID: 'Enter the ID of the world you want to read',
  worldID: 'World ID',
  enterCellId: 'Enter the ID of the cell you want to read',
  cellId: 'Cell ID',
  worldInformation: 'Read the world information successfully',
  number: 'Number',
  worldCellCount: 'World cell count:',
  worldAdaptability: 'World adaptability:',
  worldSurvivability: 'World survivability:',
  worldReproductiveness: 'World reproductiveness:',
  worldExternalEnvironmen: 'The external environment of the world:',
  worldSurvivalDay: 'World Survival Day:',
  overallScore: 'Overall score:',
  worldTitle: 'World title:',
  groupHasBeenDestroyed: '{{number}} group has been destroyed. Please pay attention to the balanced development of ethnic groups. Blindly chasing high scores may not bring victory. -Ling',
  finalEvaluation: 'Final evaluation:',
  finalScore: 'Final score:',
  cellCreator: 'Cell creator',
  ethnicGroup: 'Ethnic group',
  cellInformationSuccessfully: 'Read cell information successfully',
  readWorldDataFailed: 'Failed to read world data',
  worldAndcell: 'World data and cellular information',
  details: 'Details',
  gameOver: 'Game Over',
  isUploadDNA: 'Is the DNA uploaded and integrated into the community?',
  veryLittle: 'very little',
  minority: 'minority',
  less: 'less',
  medium: 'medium',
  more: 'more',
  many: 'many',
  superMulti: 'super multi',
  countlessMillions: 'countless millions',
  supercell: 'super cell',
  eukaryoticCells: 'eukaryotic cells',
  prokaryoticCells: 'prokaryotic cells',
  paleonuclearCells: 'paleonuclear cells',
  singleCell: 'single cell',
  zombie: 'zombie',
  zombieSubspecies: 'zombieSubspecies',
  normal: 'normal',
  superbEnvironmentalResistance: 'superb environmental resistance',
  strongEnvironmentalResistance: 'strong environmental resistance',
  weakerEnvironmentalResistance: 'weaker environmental resistance',
  weakEnvironmentalResistance: 'weak environmental resistance',
  superbAdaptation: 'superb adaptation',
  superSurvival: 'super survival',
  superbBreeding: 'superb breeding',
  SuccessfulOperation: 'Successful operation',
  OperationFailed: 'Operation failed'
}
